<body class="dashboard dashboard-bg superadmin-dashboard">
  <app-header></app-header>

  <div class="body-container collapsed">
    <app-sidebar></app-sidebar>

    <div class="body-content">
      <div class="row">
        <div class="col-md-8 p-0">
          <app-page-header [title]="'Tenants' | translate" iconClass="fas fa-building"></app-page-header>
        </div>

        <div class="col-md-4 p-0">
          <div class="text-right grid-button-container">
            <button type="button" class="btn button-primary" (click)="addTenant()" mat-button>
              {{ 'Add Tenant' | translate }}
            </button>
          </div>
        </div>
      </div>

      <app-progress-spinner [show]="isLoading || (dataSource.isLoading$ | async)"></app-progress-spinner>

      <div class="white-box">
        <mat-form-field>
          <mat-label>{{ 'Search' | translate }}</mat-label>
          <input matInput #searchField />
          <mat-icon matPrefix class="mr-3">
            <i class="fas fa-search"></i>
          </mat-icon>
        </mat-form-field>

        <table mat-table [dataSource]="dataSource" matSort matSortActive="name" matSortDirection="asc"
          matSortDisableClear>
          <ng-container matColumnDef="name">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> {{ 'Name' | translate }} </th>
            <td mat-cell *matCellDef="let tenant">
              <div class="grid-link" (click)="showUsers(tenant)">
                {{tenant.name}}
              </div>
            </td>
          </ng-container>

          <ng-container matColumnDef="status">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> {{ 'Status' | translate }} </th>
            <td mat-cell *matCellDef="let tenant">
              @if (tenant.status) {
                <mat-icon [title]="'Enabled' | translate">
                  <i class="fas fa-check-circle color-secondary"></i>
                </mat-icon>
              }

              @if (!tenant.status) {
                <mat-icon [title]="'Disabled' | translate">
                  <i class="fas fa-minus-circle color-accent"></i>
                </mat-icon>
              }
            </td>
          </ng-container>

          <ng-container matColumnDef="isDistributed">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> {{ 'Distributed' | translate }} </th>
            <td mat-cell *matCellDef="let tenant">
              @if (tenant.isDistributed) {
                <mat-icon [title]="'Distributed' | translate">
                  <i class="fas fa-sitemap color-secondary"></i>
                </mat-icon>
              }

              @if (!tenant.isDistributed) {
                <mat-icon [title]="'Single region' | translate">
                  <i class="fas fa-minus"></i>
                </mat-icon>
              }
            </td>
          </ng-container>

          <ng-container matColumnDef="dateCreated">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> {{ 'Date Created' | translate }} </th>
            <td mat-cell *matCellDef="let tenant"> {{tenant.dateCreated | dateFormat }} </td>
          </ng-container>

          <ng-container matColumnDef="dateUpdated">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> {{ 'Date Updated' | translate }} </th>
            <td mat-cell *matCellDef="let tenant"> {{tenant.dateUpdated | dateFormat }} </td>
          </ng-container>

          <ng-container matColumnDef="action">
            <th class="action-column" mat-header-cell *matHeaderCellDef> {{ 'Action' | translate }} </th>
            <td class="action-column" mat-cell *matCellDef="let tenant">
              <mat-icon class="action-icon" [title]="'Edit' | translate" (click)="editTenant(tenant)">
                <i class="fas fa-edit"></i>
              </mat-icon>

              <mat-icon class="action-icon" [title]="'Edit Logo' | translate" (click)="editLogo(tenant)">
                <i class="fas fa-image"></i>
              </mat-icon>

              @if (tenant.status) {
                <mat-icon class="action-icon" [title]="'Disable' | translate"
                  (click)="changeStatus(tenant, false)">
                  <i class="fas fa-toggle-on"></i>
                </mat-icon>
              }

              @if (!tenant.status) {
                <mat-icon class="action-icon" [title]="'Enable' | translate"
                  (click)="changeStatus(tenant, true)">
                  <i class="fas fa-toggle-off"></i>
                </mat-icon>
              }

              <mat-icon class="action-icon color-accent" [title]="'Delete' | translate" (click)="delete(tenant)">
                <i class="fas fa-trash"></i>
              </mat-icon>
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; let even = even; columns: displayedColumns;"
          [class.even-row]="even"></tr>
        </table>

        <mat-paginator [length]="dataSource.count$ | async" [pageSizeOptions]="[5, 10, 20]" [pageSize]="10"
        showFirstLastButtons></mat-paginator>
      </div>

      <div class="row">
        <div class="col-lg-3 offset-lg-9">
          <mat-form-field>
            <mat-label>{{ 'Time Zone' | translate }}</mat-label>
            <input matInput [(ngModel)]="timeZoneLabel" readonly />
            <mat-icon matPrefix class="mr-3">
              <i class="fas fa-globe"></i>
            </mat-icon>
          </mat-form-field>
        </div>
      </div>

      <div class="clearfix"></div>
      <app-footer></app-footer>
    </div>

    <div class="clearfix"></div>
  </div>
</body>
